module.exports = __webpack_public_path__ + "img/DSC_0020.01d8cd8e.jpg";